import { render, staticRenderFns } from "./VerticalGallery.vue?vue&type=template&id=c8cc12a0&scoped=true&"
import script from "./VerticalGallery.vue?vue&type=script&lang=js&"
export * from "./VerticalGallery.vue?vue&type=script&lang=js&"
import style0 from "./VerticalGallery.vue?vue&type=style&index=0&id=c8cc12a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8cc12a0",
  null
  
)

export default component.exports